import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/Houzzdat_logo.jpg';
import { useAuth } from '../AuthContext';
import { supabase } from '../supabaseClient';

const Navbar = () => {
  const { user, signOut } = useAuth();
  const [role, setRole] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRole = async () => {
      if (user) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('role')
          .eq('id', user.id)
          .single();
        setRole(profile?.role || null);
      } else {
        setRole(null);
      }
    };
    fetchRole();
  }, [user]);

  const handleLogout = async () => {
    await signOut();
    navigate('/');
  };

  const navLinks = (
    <>
      <Link to="/" className="text-primary font-medium hover:text-accent transition" onClick={() => setMenuOpen(false)}>Home</Link>
      {role === 'admin' && (
        <Link to="/admin" className="text-primary font-medium hover:text-accent transition" onClick={() => setMenuOpen(false)}>Admin</Link>
      )}
      {role === 'admin' && (
        <Link to="/analytics" className="text-primary font-medium hover:text-accent transition" onClick={() => setMenuOpen(false)}>Analytics</Link>
      )}
      <Link to="/blog" className="text-primary font-medium hover:text-accent transition" onClick={() => setMenuOpen(false)}>Blog</Link>
      {user && (
        <Link to="/my-quotes" className="text-primary font-medium hover:text-accent transition" onClick={() => setMenuOpen(false)}>My Quotes</Link>
      )}
      {user && (
        <Link to="/product-pricing" className="text-primary font-medium hover:text-accent transition" onClick={() => setMenuOpen(false)}>{"Today's price"}</Link>
      )}
      {!user ? (
        <Link to="/login" className="text-primary font-medium hover:text-accent transition" onClick={() => setMenuOpen(false)}>Login</Link>
      ) : (
        <>
          <Link to="/profile" className="text-primary font-medium hover:text-accent transition" onClick={() => setMenuOpen(false)}>Profile</Link>
          <button onClick={() => { handleLogout(); setMenuOpen(false); }} className="text-primary font-medium hover:text-accent transition">Logout</button>
        </>
      )}
      <a href="#lead-capture" className="hidden md:inline-block ml-4 px-4 py-2 bg-accent text-white rounded-xl shadow-soft font-semibold hover:bg-primary transition">Request a Quote</a>
    </>
  );

  return (
    <nav className="sticky top-0 z-50 bg-background shadow-soft flex items-center justify-between px-6 py-3">
      <div className="flex items-center gap-2">
        <img src={logo} alt="Houzzdat Logo" className="h-10 w-auto" />
      </div>
      {/* Desktop Nav */}
      <div className="hidden md:flex items-center gap-4">{navLinks}</div>
      {/* Burger Menu Button */}
      <button
        className="md:hidden flex flex-col justify-center items-center w-10 h-10 focus:outline-none"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span className={`block w-6 h-0.5 bg-primary mb-1 transition-transform ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
        <span className={`block w-6 h-0.5 bg-primary mb-1 ${menuOpen ? 'opacity-0' : ''}`}></span>
        <span className={`block w-6 h-0.5 bg-primary transition-transform ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
      </button>
      {/* Mobile Nav */}
      {menuOpen && (
        <div className="absolute top-full left-0 w-full bg-background shadow-lg flex flex-col items-center gap-4 py-4 md:hidden z-50">
          {navLinks}
        </div>
      )}
    </nav>
  );
};

export default Navbar; 